module.exports = __webpack_public_path__ + "mobile/img/card-banner.669c6ca4.png";